import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-6" };
import CompareAnthropometry from '@ts/components/analysis/CompareAnthropometry.vue';
import CompareOxygen from '@ts/components/analysis/CompareOxygen.vue';
import CompareLactate from '@ts/components/analysis/CompareLactate.vue';
import CompareThreshold from '@ts/components/analysis/CompareThreshold.vue';
import CompareFat from '@ts/components/analysis/CompareFat.vue';
import CompareChartLactate from '@ts/components/analysis/CompareChartLactate.vue';
import CompareChartMetabolism from '@ts/components/analysis/CompareChartMetabolism.vue';
import CompareChartSubstrate from '@ts/components/analysis/CompareChartSubstrate.vue';
import CompareHrFueling from '@ts/components/analysis/CompareHrFueling.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Comparison',
    props: {
        dataA: {},
        dataB: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CompareAnthropometry, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareOxygen, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareLactate, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareThreshold, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareFat, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareHrFueling, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareChartLactate, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareChartMetabolism, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"]),
                _createVNode(CompareChartSubstrate, {
                    dataA: __props.dataA,
                    dataB: __props.dataB,
                    help: true
                }, null, 8 /* PROPS */, ["dataA", "dataB"])
            ]));
        };
    }
});
